"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
/**
 * A token to use with InversifyJS injection.
 */
var Token = /** @class */ (function () {
    function Token(identifier) {
        this.identifier = identifier;
    }
    return Token;
}());
exports.Token = Token;
/**
 * Get an item represented by a token from a container.
 */
exports.getToken = function (container, token) {
    return container.get(token.identifier);
};
/**
 * Get all items represented by a token from a container.
 */
exports.getAllToken = function (container, token) {
    return container.getAll(token.identifier);
};
/**
 * Get an item represented by a token with a given name.
 */
exports.getNamed = function (container, token, named) {
    return container.getNamed(token.identifier, named);
};
/**
 * Get an item represented by a token with a tag.
 */
exports.getTagged = function (container, token, key, value) {
    return container.getTagged(token.identifier, key, value);
};
/**
 * Inject an item represented by a token.
 */
exports.injectToken = function (token) {
    return inversify_1.inject(token.identifier);
};
/**
 * Inject multiple items represented by a token.
 */
exports.multiInjectToken = function (token) {
    return inversify_1.multiInject(token.identifier);
};
/**
 * Wrap a bind function to allow binding tokens.
 */
exports.tokenBinder = function (bind) { return function (token) { return bind(token.identifier); }; };
/**
 * Wrap an unbind function to allow unbinding tokens.
 */
exports.tokenUnbinder = function (unbind) { return function (token) { return unbind(token.identifier); }; };
/**
 * Wrap an isBound function to allow checking tokens.
 */
exports.tokenIsBound = function (isBound) { return function (token) { return isBound(token.identifier); }; };
/**
 * Wrap a rebind function to allow checking tokens.
 */
exports.tokenRebinder = function (rebind) { return function (token) { return rebind(token.identifier); }; };
/**
 * A ContainerModule that uses tokens exclusively.
 *
 * If you need to mix and match tokens and regular symbols in the same module then use ContainerModule and manually wrap
 * functions you need.
 *
 * @see tokenBinder
 */
var TokenContainerModule = /** @class */ (function (_super) {
    __extends(TokenContainerModule, _super);
    function TokenContainerModule(registry) {
        return _super.call(this, function (bind, unbind, isBound, rebind) {
            registry(exports.tokenBinder(bind), exports.tokenUnbinder(unbind), exports.tokenIsBound(isBound), exports.tokenRebinder(rebind));
        }) || this;
    }
    return TokenContainerModule;
}(inversify_1.ContainerModule));
exports.TokenContainerModule = TokenContainerModule;
/**
 * An AsyncContainerModule that uses tokens exclusively.
 *
 * If you need to mix and match tokens and regular symbols in the same module then use
 * AsyncContainerModule and manually wrap functions you need.
 * @see tokenBinder
 */
var AsyncTokenContainerModule = /** @class */ (function (_super) {
    __extends(AsyncTokenContainerModule, _super);
    function AsyncTokenContainerModule(registry) {
        var _this = _super.call(this, function (bind, unbind, isBound, rebind) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, registry(exports.tokenBinder(bind), exports.tokenUnbinder(unbind), exports.tokenIsBound(isBound), exports.tokenRebinder(rebind))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }) || this;
        return _this;
    }
    return AsyncTokenContainerModule;
}(inversify_1.AsyncContainerModule));
exports.AsyncTokenContainerModule = AsyncTokenContainerModule;
//# sourceMappingURL=data:application/json;base64,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